"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Sort(_ref) {
  var i18n = _ref.i18n,
      defaultOption = _ref.defaultOption,
      _onChange = _ref.onChange;

  return _react2.default.createElement(
    "div",
    { className: "result-sort-box" },
    _react2.default.createElement(
      "div",
      { className: "result-sort-selector" },
      _react2.default.createElement(
        "label",
        { className: "result-sort-label", htmlFor: "result-sort-title" },
        _react2.default.createElement(
          "div",
          { className: "result-sort-title" },
          i18n.sort.sort
        ),
        _react2.default.createElement(
          "select",
          { className: "result-sort", value: defaultOption, onChange: function onChange(e) {
              return _onChange(e.target.value);
            } },
          _react2.default.createElement(
            "option",
            { value: "recommend desc" },
            i18n.sort.recommended
          ),
          _react2.default.createElement(
            "option",
            { value: "review desc" },
            i18n.sort.guestRating
          ),
          _react2.default.createElement(
            "option",
            { value: "rate desc" },
            i18n.sort.hotelRating
          ),
          _react2.default.createElement(
            "option",
            { value: "price" },
            i18n.sort.priceLowToHigh
          ),
          _react2.default.createElement(
            "option",
            { value: "price desc" },
            i18n.sort.priceHighToLow
          )
        )
      )
    )
  );
} // Sort

Sort.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  defaultOption: _react.PropTypes.string,
  // functions
  onChange: _react.PropTypes.func.isRequired
};

exports.default = Sort;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/components/Sort.js
// module id = 1225
// module chunks = 0